import React, { useState } from "react";
import {
    Card, Tabs, Checkbox, ColorPicker, Slider, InputNumber,
    Row, Col, Radio, Select, Input
} from "antd";

const { Option } = Select;
const { TabPane } = Tabs;
const { Search } = Input;

const DebugPanel = (props) => {
    const [searchValue, setSearchValue] = useState("");

    const filteredOptions = props.configuratorOptions?.filter((item) =>
        item.product_id.toLowerCase().includes(searchValue.toLowerCase())
    );

    const renderDebugOptions = () => (
        <>
            <Checkbox style={{ fontSize: "small" }} onChange={props.onAutoRotate} defaultChecked={false}>Auto Rotate</Checkbox>
            <br />
            <Checkbox style={{ fontSize: "small" }} onChange={props.onDebugWireframe}>Wireframe Mode</Checkbox>
            <br />
            {props.wireframeMode && (
                <>
                    <Row align="middle" gutter={8} wrap={false} style={{ marginTop: "8px", marginBottom: "8px" }}>
                        <Col flex="90px"><span style={{ fontSize: "13px" }}>Opacity:</span></Col>
                        <Col flex="auto">
                            <Slider
                                min={0.01}
                                max={1.0}
                                step={0.01}
                                value={typeof props.wireframeOpacity === 'number' ? props.wireframeOpacity : 0.5}
                                onChange={props.onWireframeOpacityChange}
                            />
                        </Col>
                        <Col flex="70px">
                            <InputNumber
                                min={0.01}
                                max={1.0}
                                step={0.01}
                                value={props.wireframeOpacity}
                                onChange={props.onWireframeOpacityChange}
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                    <Row align="middle" gutter={8} wrap={false} style={{ marginTop: "8px", marginBottom: "8px" }}>
                        <Col flex="90px"><span style={{ fontSize: "13px" }}>Thickness:</span></Col>
                        <Col flex="auto">
                            <Slider
                                min={0.1}
                                max={10.0}
                                step={0.1}
                                value={typeof props.wireframeThickness === 'number' ? props.wireframeThickness : 1.0}
                                onChange={props.onWireframeThicknessChange}
                            />
                        </Col>
                        <Col flex="70px">
                            <InputNumber
                                min={0.1}
                                max={10.0}
                                step={0.1}
                                value={props.wireframeThickness}
                                onChange={props.onWireframeThicknessChange}
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                </>
            )}
            <Checkbox style={{ fontSize: "small" }} onChange={props.onDebugUV}>UV Mode</Checkbox>
            <br />
            <Checkbox style={{ fontSize: "small" }} onChange={props.onDebugPatterns}>Patterns Mode</Checkbox>
            <br />
            {props.uvSliderVisibility ? (
                <Row>
                    <Col span={12}>
                        <Slider
                            min={0.01}
                            max={10.0}
                            onChange={props.onUVScaleChange}
                            value={typeof props.uvScale === 'number' ? props.uvScale : 0}
                            step={0.01}
                        />
                    </Col>
                    <Col span={4}>
                        <InputNumber
                            min={0.01}
                            max={10.0}
                            style={{ margin: '0 16px' }}
                            step={0.01}
                            value={props.uvScale}
                            onChange={props.onUVScaleChange}
                        />
                    </Col>
                </Row>
            ) : props.patternsMode && (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "10px 20px" }}>
                    <div id="select-material" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span>Material Nodes:</span>
                        <Select
                            style={{ width: 150, height: 25 }}
                            onChange={props.onChangeMaterialNode}
                            value={props.selectedMaterialNode}
                        >
                            {props.materialNodes.map((node) => (
                                <Option key={node} value={node}>{node}</Option>
                            ))}
                        </Select>
                    </div>

                    <div>
                        <span>Patterns:</span>
                        <div style={{ display: "flex", gap: "4px", marginTop: "5px" }}>
                            {props.patternOptions.map((pattern) => (
                                <div
                                    key={pattern.value}
                                    onClick={() => props.onChangePattern(pattern.value)}
                                    style={{
                                        border: pattern.value === props.selectedPattern ? "2px solid #1890ff" : "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "2px",
                                        cursor: "pointer",
                                        width: "40px",
                                        height: "38px"
                                    }}
                                >
                                    <img
                                        src={pattern.image}
                                        alt={pattern.value}
                                        title={pattern.value}
                                        style={{ width: '40px', height: "38px" }}
                                    />
                                </div>
                            ))}
                            <div onClick={props.onChangePatternRotation} style={{
                                display: "flex", marginLeft: "20px", height: "42px",
                                alignItems: "center", cursor: "pointer", color: "#276DD7", fontWeight: "bold"
                            }}>
                                <img style={{ width: "20px", padding: "5px" }} src={"/img/rotate.svg"} alt="Rotate" />
                                Rotate
                            </div>
                        </div>
                    </div>

                    <Row align="middle" gutter={8} wrap={false}>
                        <Col flex="70px"><span style={{ fontSize: "13px" }}>X Repeat:</span></Col>
                        <Col flex="auto">
                            <Slider
                                min={0.01}
                                max={10.0}
                                step={0.01}
                                value={typeof props.xRepeat === 'number' ? props.xRepeat : 0}
                                onChange={props.onXRepeatChange}
                            />
                        </Col>
                        <Col flex="70px">
                            <InputNumber
                                min={0.01}
                                max={10.0}
                                step={0.01}
                                value={props.xRepeat}
                                onChange={props.onXRepeatChange}
                                style={{ width: "100%" }}
                                onKeyDown={(e) => {
                                    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '.', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                                    if (!allowedKeys.includes(e.key) && !(e.ctrlKey || e.metaKey)) e.preventDefault();
                                    if (e.key === '.' && e.currentTarget.value.includes('.')) e.preventDefault();
                                }}
                            />
                        </Col>
                    </Row>

                    <Row align="middle" gutter={8} wrap={false}>
                        <Col flex="70px"><span style={{ fontSize: "13px" }}>Y Repeat:</span></Col>
                        <Col flex="auto">
                            <Slider
                                min={0.01}
                                max={10.0}
                                step={0.01}
                                value={typeof props.yRepeat === 'number' ? props.yRepeat : 0}
                                onChange={props.onYRepeatChange}
                            />
                        </Col>
                        <Col flex="70px">
                            <InputNumber
                                min={0.01}
                                max={10.0}
                                step={0.01}
                                value={props.yRepeat}
                                onChange={props.onYRepeatChange}
                                style={{ width: "100%" }}
                                onKeyDown={(e) => {
                                    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '.', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                                    if (!allowedKeys.includes(e.key) && !(e.ctrlKey || e.metaKey)) e.preventDefault();
                                    if (e.key === '.' && e.currentTarget.value.includes('.')) e.preventDefault();
                                }}
                            />
                        </Col>
                    </Row>

                    <Checkbox checked={props.repeatLock} style={{ fontSize: "small" }} onChange={props.onChangeRepeatLock}>
                        Lock Repeat
                    </Checkbox>
                </div>
            )}
            <br />
            <span>Background Color</span>
            <br />
            <ColorPicker
                value={props.backgroundColor}
                disabledAlpha
                onChange={(color) => props.onBackgroundColorChange(color.toHexString())}
            />
            <br /><br />
            <span>Tone Mapping</span>
            <br />
            <Radio.Group
                onChange={(ev) => {
                    props.setToneMapping(ev.target.value);
                    props.setGLToneMapping(props.toneMappingOptions[ev.target.value]);
                }}
                value={props.toneMapping}
            >
                {
                    Object.entries(props.toneMappingOptions).map(([key], index) => (
                        <React.Fragment key={key}>
                            {index !== 0 && index % 3 === 0 && <br />}
                            <Radio value={key}>{key}</Radio>
                        </React.Fragment>
                    ))
                }
            </Radio.Group>
            <br /><br />
            <span>Environment HDR</span>
            <br />
            <Radio.Group
                onChange={(ev) => {
                    props.setEnvironmentHDR(ev.target.value);
                }}
                value={props.environmentHDR}
            >
                {
                    Object.keys(props.hdrEnvironmentOptions).map((key, index) => (
                        <React.Fragment key={key}>
                            {index !== 0 && index % 3 === 0 && <br />}
                            <Radio value={key}>{key}</Radio>
                        </React.Fragment>
                    ))
                }
            </Radio.Group>
        </>
    );

    const renderConfiguratorMode = () => (
        <>
            <Search
                placeholder="Search Configurator"
                style={{ marginBottom: 8 }}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                allowClear
            />
            <div id = 'configurator-menu'>
                {filteredOptions?.map((item, index) => (
                    <Card
                        id="configurator-card"
                        key={index}
                        hoverable
                        size="small"
                        cover={item.thumbnail && (
                            <div id="configurator-card-img-container">
                                <img
                                    id="configurator-card-img"
                                    alt={item.product_id}
                                    src={item.thumbnail}
                                />
                                {item.status && (
                                    <div className="card-status-badge">
                                        {item.status}
                                    </div>
                                )}
                            </div>
                        )}
                        className={props.selectedProducts.includes(item.glb_url) ? "selected" : ''}
                        onClick={() => props.onConfiguratorSelect?.(item.glb_url)}
                    >
                        <div id="configurator-card-tag">
                            {item.product_id}
                        </div>
                    </Card>
                ))}

            </div>
        </>
    );

    return props.showConfiguratorMode ? (
        <Tabs defaultActiveKey="1" tabBarStyle={{ marginBottom: 16 }} onChange={props.onTabChange}>
            <TabPane tab="Debug Options" key="1">
                {renderDebugOptions()}
            </TabPane>
            <TabPane tab="Configurator Mode" key="2">
                {renderConfiguratorMode()}
            </TabPane>
        </Tabs>
    ) : (
        <div style={{ paddingRight: 4 }}>
            {renderDebugOptions()}
        </div>
    );
};

export default DebugPanel;
